import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '../special/LanguageProvider';

const SimpleFileUploadButton = ({onSelectedFile, fileType, uploadText}) => {   
    const fileInput = useRef(null);    
    const { t } = useLocale();

    let id = "fileinput_" + new Date().getTime() + Math.floor(Math.random() * 100);
    
    let uploadTextCls = 'button link icon-upload3';   

    const changeFile = (e) => {
        const file = e.target.files.length > 0 ? e.target.files[0] : null;
        if(file) {
            console.log("Thefile", file);
            if (onSelectedFile){
              console.log("Sending file as selected");
              onSelectedFile(file);
            }
        }
    }

    const handleUpload = () => {
        fileInput.current.click();
    }

    return (        
      <div className="form-file-upload">         
            <div>                
                <input  
                    style={{ display: 'none' }}          
                    ref={fileInput}
                    name={id}
                    type="file"
                    onChange={changeFile}
                    accept={fileType}
                />                           
                <span className={uploadTextCls} onClick={handleUpload}>
                    {!uploadText && (<span> {t("Ýttu hér til að velja skrá")} </span>)} 
                    {uploadText && {uploadText}}
                </span> 
            </div>
      </div>
    );
};





SimpleFileUploadButton.propTypes = {
    onSelectedFile: PropTypes.func,  
};
 
export default SimpleFileUploadButton;
